import { useEffect } from 'react';

/**
 * Runs an effect once the component is mounted.
 * This is so we don't need to have a bunch of `eslint-disable-next-line react-hooks/exhaustive-deps`
 * all over the place
 *
 * @param {Function} callback
 */
export function useComponentDidMount(callback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
}
